module.exports = __webpack_public_path__ + "static/media/montserrat-v15-latin-ext_latin_cyrillic-ext_cyrillic-regular.cb718955.woff2";